import { render, staticRenderFns } from "./newTransScanIn_v2.vue?vue&type=template&id=39d987a6&scoped=true&"
import script from "./newTransScanIn_v2.vue?vue&type=script&lang=js&"
export * from "./newTransScanIn_v2.vue?vue&type=script&lang=js&"
import style0 from "./newTransScanIn_v2.vue?vue&type=style&index=0&id=39d987a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d987a6",
  null
  
)

component.options.__file = "newTransScanIn_v2.vue"
export default component.exports